document.addEventListener("DOMContentLoaded", function() {
    const modal = document.getElementById('contactModal');
    const closeModalBtn = document.querySelector('.close-btn');
    const openModalBtns = document.querySelectorAll('.open-modal-btn');

    function openModal(e) {
        e.preventDefault();
        modal.style.display = 'block';
    }

    function closeModal() {
        modal.style.display = 'none';
    }

    // Ouvrir la modale
    openModalBtns?.forEach(function(btn) {
        btn.addEventListener('click', openModal);
    });

    // Fermer la modale
    closeModalBtn?.addEventListener('click', closeModal);

    // Fermer la modale en cliquant en dehors
    window.addEventListener('click', function(e) {
        if (e.target === modal) {
            closeModal();
        }
    });
});
